import { render, staticRenderFns } from "./DuplicationReasonRequirement.vue?vue&type=template&id=3f22b847&scoped=true"
import script from "./DuplicationReasonRequirement.vue?vue&type=script&lang=ts"
export * from "./DuplicationReasonRequirement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f22b847",
  null
  
)

export default component.exports